export function initPrototypesFunctions(){
  Date.prototype.toLocaleDateStringAbs = function() {
    return `${this.getFullYear()}/${this.getMonth()+1}/${this.getDate()}`
  }
}
